import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const SystemSet: RouteConfig = {
  path: '/system-set',
  component: Layout,
  redirect: 'noredirect',
  name: 'SystemSet',
  meta: {
    title: 'systemset',
    permission: 'SystemSet',
    icon: 'guide'
  },
  children: [{
    path: 'personal-info/index',
    component: () => import(/* webpackChunkName: "userGetUserById" */ '@/views/systemset/personalinfo/index.vue'),
    name: 'userGetUserById',
    meta: {
      title: 'personalinfo',
      permission: 'userGetUserById',
      noCache: true,
      icon: 'sys-info'
    }
  },
  {
    path: 'user-manage/index',
    component: () => import(/* webpackChunkName: "userManage" */ '@/views/systemset/usermanage/index.vue'),
    name: 'lbCompanyUser',
    meta: {
      title: 'lbCompanyUser',
      permission: 'lbCompanyUser',
      noCache: true,
      icon: 'guide'
    }
  },
  {
    path: 'operate-log/index',
    component: () => import(/* webpackChunkName: "operationLog" */ '@/views/systemset/operatelog/index.vue'),
    name: 'operationLog',
    meta: {
      title: 'operatelog',
      permission: 'operationLog',
      noCache: true,
      icon: 'sys-log'
    }
  },
  {
    path: '/operate-log-detail',
    component: () => import(/* webpackChunkName: "operatelogdetail" */ '@/views/systemset/operatelog/detail/index.vue'),
    name: 'operatelogdetail',
    meta: {
      title: 'operatelogdetail',
      activeMenu: '/system-set/operate-log/index',
      hidden: true,
      icon: 'guide'
    }
  },
  {
    path: 'protocol-config/index',
    component: () => import(/* webpackChunkName: "serviceAgreement" */ '@/views/systemset/protocolconfig/index.vue'),
    name: 'serviceAgreement',
    meta: {
      title: 'serviceAgreement',
      permission: 'serviceAgreement',
      noCache: true,
      icon: 'sys-protocol'
    }
  },
  {
    path: 'user-auth/index',
    component: () => import(/* webpackChunkName: "userPower" */ '@/views/systemset/userauth/index.vue'),
    name: 'userAuthList',
    meta: {
      title: 'userPower',
      permission: 'userPower',
      noCache: true,
      icon: 'agent-manage'
    }
  },
  {
    path: '/user-auth-edit/index',
    component: () => import(/* webpackChunkName: "userAuthEdit" */ '@/views/systemset/userauth/edit/index.vue'),
    name: 'userAuthEdit',
    meta: {
      title: 'userAuthEdit',
      activeMenu: '/system-set/user-auth/index',
      hidden: true,
      icon: 'guide'
    }
  }]
}

export default SystemSet
